export default "__VITE_ASSET__DA0IG2R___"